import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

export default function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const expired = params.get("expired") === "1";

  const checkout = async () => {
    if (!user) { navigate("/signup"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Erreur de checkout");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
          <Link to={user ? "/app" : "/"} className="text-sm text-slate-500 inline-flex items-center gap-1 link-underline" data-testid="pricing-back">
            <ArrowLeft className="w-3 h-3" /> Retour
          </Link>
          <div className="font-display text-2xl tracking-tight">Xpert Recruit AI</div>
          <div />
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 lg:py-24 text-center">
        {expired && (
          <div className="max-w-xl mx-auto mb-10 bg-amber-50 border border-amber-200 rounded-lg p-5 text-left" data-testid="pricing-expired-banner">
            <div className="font-display text-lg text-amber-900 mb-1">⏰ Votre essai gratuit est terminé</div>
            <p className="text-sm text-amber-800">Pour continuer à utiliser Xpert Recruit AI, activez votre abonnement Pro. Toutes vos données sont conservées.</p>
          </div>
        )}
        <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-4">Plan Pro</div>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tight">Tout, pour un prix simple.</h1>
        <div className="mt-10 inline-block relative">
          <div className="absolute inset-0 bg-[#0F172A] translate-x-3 translate-y-3" />
          <div className="relative bg-white border-2 border-slate-900 p-10 text-left max-w-md">
            <div className="font-display text-6xl tracking-tight">$50<span className="text-2xl text-slate-400">/mois</span></div>
            <div className="text-slate-500 mt-2">Annulable à tout moment</div>
            <ul className="mt-8 space-y-3 text-sm">
              {[
                "Candidats & postes illimités",
                "Justifications IA traçables",
                "Plans d'entretien complets",
                "Triage anti-erreurs",
                "Matching barrières (must-have)",
                "Calendrier intelligent",
                "Post-mortem & apprentissage",
                "Copilote de décision",
                "Messages RH personnalisés",
                "Support prioritaire",
              ].map((f, i) => (
                <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" /> {f}</li>
              ))}
            </ul>
            <Button onClick={checkout} disabled={loading} className="w-full mt-8 bg-[#2563EB] hover:bg-[#1D4ED8] btn-pill h-12 text-base" data-testid="pricing-checkout-btn">
              {loading ? "Redirection…" : (user ? "Souscrire maintenant" : "Créer un compte & souscrire")}
            </Button>
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-8">Paiement sécurisé via Stripe. Aucune information bancaire stockée par Xpert Recruit AI.</p>
      </main>
    </div>
  );
}
